import { injectable } from 'inversify';
import { type UIConfigSchema } from './UIConfigSchema';

export type NestedKeyOf<ObjectType extends object> = {
  [Key in keyof ObjectType & (string | number)]: ObjectType[Key] extends object
    ? `${Key}` | `${Key}.${NestedKeyOf<ObjectType[Key]>}`
    : `${Key}`;
}[keyof ObjectType & (string | number)];

@injectable()
export class UIConfigResolver {
  private _config?: UIConfigSchema;

  public setSurgerySpecificConfig(config: UIConfigSchema): void {
    this._config = config;
  }

  public surgerySpecificConfigHasBeenSet(): boolean {
    return this._config !== undefined;
  }

  // TODO: infer return type from schema
  public getOptionalValueByDescriptor<R>(descriptor: NestedKeyOf<UIConfigSchema>): R | undefined {
    if (!this._config) {
      throw new Error('UI config not set');
    }
    const parts = descriptor.split('.');
    let current = this._config as unknown as Record<string, unknown>;
    for (const part of parts) {
      if (!current.hasOwnProperty(part)) {
        return undefined;
      }
      current = current[part] as Record<string, unknown>;
    }
    return current as R;
  }

  public getValueByDescriptor<R>(descriptor: NestedKeyOf<UIConfigSchema>): R {
    if (!this._config) {
      throw new Error('UI config not set');
    }
    const value = this.getOptionalValueByDescriptor<R>(descriptor);
    if (value === undefined) {
      throw new Error(`Value not found for descriptor: ${descriptor}`);
    }
    return value;
  }
}
